import React from "react";

import { SignUp } from "features/Auth/SignUp";

const SignUpPage = () => <SignUp />;

export default SignUpPage;
